import styled from 'styled-components';

export const SzeryfDesktop = styled.div`
	width: 120px;

	img {
		width: 100%;
		height: auto;
	}

	@media (max-width: 600px) {
		display: none;
	}
`;
export const PlanWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-top: 8px;
	width: 360px;

	@media (min-width: 600px) {
		width: 550px;
	}
`;

export const Title = styled.div`
	color: var(--Text-color, #29185e);
	font-family: 'Work Sans';
	font-size: 16px;
	font-style: normal;
	font-weight: 700;
	line-height: 120%; /* 19.2px */

	margin-top: 4px;
`;
export const Months = styled.div`
	color: var(--Text-color, #29185e);
	font-family: 'Work Sans';
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: 120%; /* 19.2px */
`;
export const FullPrice = styled.div`
	color: var(--Text-color, #29185e);
	font-family: 'Work Sans';
	font-size: 12px;
	font-style: normal;
	font-weight: 400;
	line-height: 140%; /* 16.8px */
	min-height: 12px;
	margin-top: 24px;
`;

export const PromoPrice = styled.div`
	color: #0fa831;
	font-family: 'Work Sans';
	font-size: 16px;
	font-style: normal;
	font-weight: 700;
	line-height: 140%; /* 22.4px */

	margin-top: 4px;
`;

export const ImageWrapper = styled.div`
	width: 140px;
	position: relative;

	img {
		width: 100%;
		height: auto;
	}

	div {
		position: absolute;
		bottom: 9px;

		color: #fff;
		font-family: 'Work Sans';
		font-size: 11px;
		font-style: normal;
		font-weight: 400;
		line-height: 120%; /* 13.2px */
		width: 100%;
		text-align: center;
	}

	@media (min-width: 600px) {
		width: 160px;
	}
`;

export const TextInformationWrapper = styled.div`
	max-width: 180px;
`;

export const SpanTitle = styled.span`
	background: linear-gradient(220deg, #4322c6 28.95%, #48068a 74.94%);
	background-clip: text;
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
	font-family: 'Work Sans';
	font-size: 22px;
	font-style: normal;
	font-weight: 700;
	line-height: 120%;
	text-transform: uppercase;
`;

export const TextTitle = styled.div`
	margin-top: 20px;
	color: #29185e;
	text-align: center;
	font-family: 'Work Sans';
	font-size: 22px;
	font-style: normal;
	font-weight: 700;
	line-height: 120%; /* 26.4px */
	text-transform: uppercase;

	@media (min-width: 600px) {
		width: 550px;
	}
`;

export const TextWrapper = styled.div`
	display: flex;
	justify-content: space-between;
	width: 80vw;
	box-sizing: border-box;

	@media (min-width: 600px) {
		width: 550px;
		padding: 0;
	}
`;

export const Border = styled.div`
	width: 80vw;
	height: 1px;
	background: #868686;

	@media (min-width: 600px) {
		width: 550px;
	}
`;

export const Text = styled.div`
	color: var(--Text-color, #29185e);
	font-family: 'Work Sans';
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 140%; /* 19.6px */
`;
